"use strict";

import Css from './css';
import Select from './select';
import Ajax, {getParamsFromElement as getAjaxParamsFromElement} from './ajax';
import Effect from './effect';
import Scroll from './scroll';
import Position from './position';
import {validateAddingProductForms} from './validateAddingProductForms';
import productQtyInputDisplayEstimate from './productQtyInputDisplayEstimate';

export default {

    viewProductCategoryProductsButtons: null,

    hideProductCategoryProductsButtons: null,

    url: window.location.origin + '/api/v1/product-category/products/',

    init: function(){
        this.viewProductCategoryProductsButtons = Select.all('[data-button="view-product-category-products"]');
        this.hideProductCategoryProductsButtons = Select.all('[data-button="hide-product-category-products"]');

        if (this.viewProductCategoryProductsButtons !== null) {
            if(this.viewProductCategoryProductsButtons.length){
                for( var i= 0, len = this.viewProductCategoryProductsButtons.length; i < len; i++ )
                    this.bindViewProductCategoryProductsClickEvent(this.viewProductCategoryProductsButtons[i]);
            }
        }
        if (this.hideProductCategoryProductsButtons !== null) {
            if(this.hideProductCategoryProductsButtons.length){
                for( var i= 0, len = this.hideProductCategoryProductsButtons.length; i < len; i++ )
                    this.bindHideProductCategoryProductsClickEvent(this.hideProductCategoryProductsButtons[i]);
            }
        }
    },

    bindViewProductCategoryProductsClickEvent: function(el){
        var self = this;
        el.addEventListener('click', function(e){
            e.preventDefault();
            var categoryId = this.getAttribute('data-product-category-id'),
                ajaxParams = getAjaxParamsFromElement(this),
                ajaxToElement = Select.one(ajaxParams.resultsSelector),
                ajaxShowProgressInElement = Select.one(ajaxParams.showProgressSelector),
                showId = this.getAttribute('data-show'),
                showElement = Select.one('[data-show-id="'+ showId +'"]'),
                scrollToSelector = this.getAttribute('data-scroll-to'),
                scrollToElement = Select.one(scrollToSelector);

            if(categoryId && ajaxToElement.innerHTML === "") {
                Ajax('POST', self.url + encodeURIComponent(categoryId), { format: 'html', display_class: 'large-list' }, function (response) {
                    var responseJson = JSON.parse(response);
                    if(responseJson.data.hasOwnProperty('html'))
                        ajaxToElement.innerHTML = responseJson.data.html;
                    validateAddingProductForms( ajaxToElement );
                    productQtyInputDisplayEstimate.init(ajaxToElement);
                    self.showElementAndScroll(showElement, scrollToElement);
                });
            }
            else{
                self.showElementAndScroll(showElement, scrollToElement);
            }

        }, false);
    },

    bindHideProductCategoryProductsClickEvent: function(el){
        el.addEventListener('click', function(e){
            e.preventDefault();
            var hide = this.getAttribute('data-hide'),
                hideElement = Select.one('[data-hide-id="'+ hide +'"]'),
                scrollToSelector = this.getAttribute('data-scroll-to'),
                scrollToElement = Select.one(scrollToSelector);
            Effect.easeInStyleProperty(hideElement, 'height', Css.getStyle(hideElement,'height'), 0, 300, 'easeInOutQuad', function(s){
                Css.removeClass(hideElement, 'show');
            });
            var scrollToPosition = Position.getOffsetRect(scrollToElement);
            Scroll.scrollTo(scrollToPosition.top, function(){}, 200);
        }, false);
    },

    showElementAndScroll: function(showElement, scrollToElement){
        Css.addClass(showElement, 'show');
        var showElementHeight = Css.getStyle(showElement,'height');
        showElement.style.height = 0;
        Effect.easeInStyleProperty(showElement, 'height', 0, showElementHeight, 300, 'easeInOutQuad', function(s){});
        var scrollToPosition = Position.getOffsetRect(scrollToElement);
        Scroll.scrollTo(scrollToPosition.top, function(){}, 200);
    }
};
